const courseData = {
    "General English": {
        "label": "日常英語",
        "value": "General English",
        "slots": {
            "Mon": [
                "10:00~10:50",
                "11:00~11:50",
                "12:00~12:50",
                "13:00~13:50"
            ],
            "Tue": [
                "10:00~10:50",
                "11:00~11:50",
                "12:00~12:50",
                "13:00~13:50"
            ],
            "Wed": [
                "04:00~04:50",
                "05:00~05:50",
                "10:00~10:50",
                "11:00~11:50",
                "12:00~12:50",
                "13:00~13:50"
            ],
            "Thu": [
                "14:00~14:50",
                "15:00~15:50",
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50"
            ],
            "Fri": [
                "03:00~03:50",
                "05:00~05:50",
                "06:00~06:50",
                "10:00~10:50",
                "11:00~11:50",
                "12:00~12:50",
                "13:00~13:50",
                "14:00~14:50",
                "15:00~15:50",
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50",
                "20:00~20:50"
            ],
            "Sat": [
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50"
            ],
            "Sun": []
        }
    },
    "General Business English": {
        "label": "一般ビジネス英語",
        "value": "General Business English",
        "slots": {
            "Mon": [],
            "Tue": [],
            "Wed": [
                "04:00~04:50",
                "05:00~05:50"
            ],
            "Thu": [
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50"
            ],
            "Fri": [
                "03:00~03:50",
                "05:00~05:50",
                "06:00~06:50",
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50",
                "20:00~20:50"
            ],
            "Sat": [
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50"
            ],
            "Sun": []
        }
    },
    "Specialized Business English": {
        "label": "特化型ビジネス英語",
        "value": "Specialized Business English",
        "slots": {
            "Mon": [],
            "Tue": [],
            "Wed": [
                "04:00~04:50",
                "05:00~05:50"
            ],
            "Thu": [],
            "Fri": [
                "03:00~03:50",
                "05:00~05:50",
                "06:00~06:50",
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50",
                "20:00~20:50"
            ],
            "Sat": [
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50"
            ],
            "Sun": []
        }
    },
    "Executive Business English": {
        "label": "エグゼクティブ英語",
        "value": "Executive Business English",
        "slots": {
            "Mon": [],
            "Tue": [],
            "Wed": [
                "04:00~04:50",
                "05:00~05:50"
            ],
            "Thu": [],
            "Fri": [
                "03:00~03:50",
                "05:00~05:50",
                "06:00~06:50",
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50",
                "20:00~20:50"
            ],
            "Sat": [
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50"
            ],
            "Sun": []
        }
    },
    "TOEFL": {
        "label": "TOEFL",
        "value": "TOEFL",
        "slots": {
            "Mon": [],
            "Tue": [],
            "Wed": [
                "04:00~04:50",
                "05:00~05:50"
            ],
            "Thu": [],
            "Fri": [
                "03:00~03:50",
                "05:00~05:50",
                "06:00~06:50",
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50",
                "20:00~20:50"
            ],
            "Sat": [
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50"
            ],
            "Sun": []
        }
    },
    "IELTS": {
        "label": "IELTS",
        "value": "IELTS",
        "slots": {
            "Mon": [],
            "Tue": [],
            "Wed": [
                "04:00~04:50",
                "05:00~05:50"
            ],
            "Thu": [
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50"
            ],
            "Fri": [
                "03:00~03:50",
                "05:00~05:50",
                "06:00~06:50",
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50",
                "20:00~20:50"
            ],
            "Sat": [
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50"
            ],
            "Sun": []
        }
    },
    "IELTS by Former Examiners": {
        "label": "IELTS(元試験官)",
        "value": "IELTS by Former Examiners",
        "slots": {
            "Mon": [],
            "Tue": [],
            "Wed": [],
            "Thu": [],
            "Fri": [
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50",
                "20:00~20:50"
            ],
            "Sat": [],
            "Sun": []
        }
    },
    "Eiken Pre-1st and Above": {
        "label": "英検準1級以上",
        "value": "Eiken Pre-1st and Above",
        "slots": {
            "Mon": [],
            "Tue": [],
            "Wed": [
                "04:00~04:50",
                "05:00~05:50"
            ],
            "Thu": [
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50"
            ],
            "Fri": [
                "03:00~03:50",
                "05:00~05:50",
                "06:00~06:50",
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50",
                "20:00~20:50"
            ],
            "Sat": [
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50"
            ],
            "Sun": []
        }
    },
    "International/Boarding School Prep": {
        "label": "インターナショナル/ボーディングスクール",
        "value": "International/Boarding School Prep",
        "slots": {
            "Mon": [],
            "Tue": [],
            "Wed": [
                "04:00~04:50",
                "05:00~05:50"
            ],
            "Thu": [],
            "Fri": [
                "03:00~03:50",
                "05:00~05:50",
                "06:00~06:50"
            ],
            "Sat": [
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50"
            ],
            "Sun": []
        }
    },
    "IB (English)": {
        "label": "IB (英語)",
        "value": "IB (English)",
        "slots": {
            "Mon": [],
            "Tue": [],
            "Wed": [
                "04:00~04:50",
                "05:00~05:50"
            ],
            "Thu": [],
            "Fri": [
                "03:00~03:50",
                "05:00~05:50",
                "06:00~06:50"
            ],
            "Sat": [
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50"
            ],
            "Sun": []
        }
    },
    "IB Non-English": {
        "label": "IB (英語以外)",
        "value": "IB Non-English",
        "slots": {
            "Mon": [],
            "Tue": [],
            "Wed": [],
            "Thu": [],
            "Fri": [],
            "Sat": [],
            "Sun": []
        }
    },
    "University Admissions Interviews/Essays (General Level)": {
        "label": "大学入試面接/エッセイ (一般レベル)",
        "value": "University Admissions Interviews/Essays (General Level)",
        "slots": {
            "Mon": [],
            "Tue": [],
            "Wed": [
                "04:00~04:50",
                "05:00~05:50"
            ],
            "Thu": [],
            "Fri": [
                "03:00~03:50",
                "05:00~05:50",
                "06:00~06:50",
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50",
                "20:00~20:50"
            ],
            "Sat": [
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50"
            ],
            "Sun": []
        }
    },
    "University Admissions Interviews/Essays (Top Level)": {
        "label": "大学入試面接/エッセイ (トップレベル)",
        "value": "University Admissions Interviews/Essays (Top Level)",
        "slots": {
            "Mon": [],
            "Tue": [],
            "Wed": [
                "04:00~04:50",
                "05:00~05:50"
            ],
            "Thu": [],
            "Fri": [
                "03:00~03:50",
                "05:00~05:50",
                "06:00~06:50"
            ],
            "Sat": [
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50"
            ],
            "Sun": []
        }
    },
    "A-Level": {
        "label": "A-Level",
        "value": "A-Level",
        "slots": {
            "Mon": [],
            "Tue": [],
            "Wed": [
                "04:00~04:50",
                "05:00~05:50"
            ],
            "Thu": [],
            "Fri": [
                "03:00~03:50",
                "05:00~05:50",
                "06:00~06:50"
            ],
            "Sat": [
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50"
            ],
            "Sun": []
        }
    },
    "TEAP": {
        "label": "TEAP",
        "value": "TEAP",
        "slots": {
            "Mon": [],
            "Tue": [],
            "Wed": [
                "04:00~04:50",
                "05:00~05:50"
            ],
            "Thu": [],
            "Fri": [
                "03:00~03:50",
                "05:00~05:50",
                "06:00~06:50"
            ],
            "Sat": [
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50"
            ],
            "Sun": []
        }
    },
    "Specialized/Custom Curriculum": {
        "label": "専門分野/特殊カリキュラム",
        "value": "Specialized/Custom Curriculum",
        "slots": {
            "Mon": [],
            "Tue": [],
            "Wed": [
                "04:00~04:50",
                "05:00~05:50"
            ],
            "Thu": [],
            "Fri": [
                "03:00~03:50",
                "05:00~05:50",
                "06:00~06:50"
            ],
            "Sat": [
                "17:00~17:50",
                "18:00~18:50",
                "19:00~19:50"
            ],
            "Sun": []
        }
    }
};

export default courseData;
